import { motion } from 'framer-motion';
import Header from '../components/Header';
import CardQuote from '../components/CardQuote';
import Img from "../assets/vaness_two_381.webp";
import Img_sec from "../assets/vaness_contact_381.webp";
import "../sass/pages/_contact.scss";

export default function Contact() {
  return (
    <>
      <Header />
      <main className='contact'>
        <motion.section 
          className="first"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          >
          <CardQuote
            src={Img}
            alt={"illustration triangulaire noir et blanc"}
            txtOne={" La guérison peut être aussi rapide que la maladie. "} authorOne={"Milton H. Erickson"}
            txtTwo={" Je ne suis pas ce qui m'est arrivé, je suis ce que je choisis de devenir "} authorTwo={"Carl Gustav JUNG"}
          />
        </motion.section>
        <motion.section 
          className="second"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: .3 }}
          viewport={{ once: true }}
          >
          <div className="contact-txt">
              <h2>TARIF</h2>
              <p>La durée de la séance varie entre 1h15 et 1h30.</p>
              <p>vous pouvez composer le 06 43 45 73 96.</p>
              <p>Si vous avez besoin de me contacter.</p>
              <p>Coût d'une séance est de 70 euros.</p>
          </div>
          <div className='contact-img'>
              <img src={Img_sec} alt="oeuf brun sur sac en papier blanc" />
          </div>
        </motion.section>
        <motion.section 
          className="third"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: .4 }}
          viewport={{ once: true }}
          >
          <div className="contact-iframe">
            <iframe aria-label="google map" title="google-map" width="100%" height="300" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" 
              src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=52%20Avenue%20de%20la%20table%20de%20pierre,%2069340%20%20Franchville+(Evanescence%20Hypnose)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
                <a href="https://www.maps.ie/population/">Population mapping</a>
            </iframe>
          </div>
          <div className="contact-txt">
            <h2>Adresse</h2>
            <p>52 Avenue de la Table de Pierre</p>
            <p>69340 - Franchville.</p>
            <p>SIRET : 978704179</p>
          </div>
          <div className="contact-txt txt-center">
            <p>Il est possible d'organiser la consultation en visioconférence ou à domicile.</p>
          </div>
          </motion.section>
      </main>
    </>
  )
}
